import {
  Module, VuexModule, Mutation, Action,
} from 'vuex-module-decorators';
import * as amplitude from 'amplitude-js';

import {
  ClientInfoDTO, UserDTO,
} from '@/api';
import service from '@/services';

type Info = {data: Array<{id: number; name: string; value: string}>};

@Module({ name: 'ClientsModule' })
export default class ClientsModule extends VuexModule {
  model: ClientInfoDTO | null = null

  stylists: UserDTO[] = [];

  info: Info | null = null;

  @Mutation
  setClient(client: ClientInfoDTO | null) {
    this.model = client;
  }

  @Mutation
  setClientInfo(info: Info) {
    this.info = info;
  }

  @Mutation
  setStylists(stylists: UserDTO[]) {
    this.stylists = stylists;
  }

  @Action({ rawError: true })
  async fetchClient(clientId: number) {
    const { data } = await service.clientsService().clientEndpointGetClientInfo(clientId);
    this.setClient(data);
    amplitude.getInstance().logEvent('Загрузка клиента', { clientId });
    return data;
  }

  @Action({ rawError: true })
  async fetchStylists() {
    const { data } = await service.commonApi().commonEndpointGetStylists();
    this.setStylists(data);
    amplitude.getInstance().logEvent('Загрузка стилистов', data);
    return data;
  }

  @Action({ rawError: true })
  async saveClient(client: ClientInfoDTO) {
    const { data } = await service.clientsService().clientEndpointSaveClientInfo(client);
    this.setClient({ ...client, id: data });
    amplitude.getInstance().logEvent('Сохранение клиента', { clientId: client.id, client });
    const clientRes = await this.fetchClient(data);
    return clientRes;
  }

  @Action({ rawError: true })
  async fetchInfo(clientId: number) {
    try {
      const { data } = await service.compilationsApi().compilationEndpointClientForm(clientId);
      const object = data as unknown as Info;
      // console.log(object);
      this.setClientInfo(object);
      return object;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e);
      return null;
    }
  }
}
